import * as maptalks from 'maptalks';

export class ToolbarControl extends maptalks.control.Toolbar {
    constructor(configSettings) {
        super(configSettings);
    }
}